import { useMemo } from 'react';
import RosterSearchAutocomplete from '../../../../RosterSearchAutocomplete/RosterSearchAutocomplete';
import { useExceptionGroupsQuery } from '../../../../../core/lms';

export default function RosterSearchWrapper({
  exceptions = [],
  roster = [],
  courseId,
  handleSelect,
}) {
  const { data: groups, isFetching } = useExceptionGroupsQuery(courseId, true);

  const { selectedGroups, studentExceptions } = useMemo(() => {
    if (exceptions.length === 0) {
      return { selectedGroups: [], studentExceptions: [] };
    }
    const assignmentException = exceptions.find(
      (ex) => ex.exception_type === 'assignment',
    );

    const selectedGroups =
      assignmentException && assignmentException.group_ids.length > 0
        ? assignmentException.group_ids
        : [];

    const studentExceptions = exceptions.flatMap(
      (exception) => exception.user_ids,
    );

    return { selectedGroups, studentExceptions };
  }, [exceptions]);

  const preloadedItems = useMemo(() => {
    return [
      ...(studentExceptions
        .map((userId) => {
          const student = roster.find(
            (student) => student.studentId === userId,
          );
          return student ? { ...student, type: 'student' } : null;
        })
        .filter(Boolean) || []),
      ...(selectedGroups
        .map((groupId) => {
          const group = groups?.find((group) => group.groupId === groupId);
          return group ? { ...group, type: 'group' } : null;
        })
        .filter(Boolean) || []),
    ];
  }, [studentExceptions, selectedGroups, roster, groups]);

  const onSelect = (value) => {
    handleSelect(value);
  };

  return (
    <div>
      <RosterSearchAutocomplete
        disabled={isFetching}
        isAssign={true}
        students={roster}
        groups={groups}
        onSelect={onSelect}
        preloadedItems={preloadedItems}
      />
    </div>
  );
}
